'use client';

import Link from 'next/link';
import Image from 'next/image';
import MarketingHeader from '@/components/MarketingHeader';
import MarketingFooter from '@/components/MarketingFooter';
import { getBrandHomeUrl } from '@/lib/creatorPlatformUrls';

export default function TeamPage() {
  return (
    <div className="home-page home-page--no-snap">
      <MarketingHeader />
      <main className="about-main">
        <h1 className="home-about-title">创始团队</h1>
        <p className="home-about-text about-main-team-intro">
          基音由拥有商业、音乐与科技多元背景的创始人带领，致力于为创作者建立长期、可信赖的支持体系。
        </p>

        <section className="about-main-founder">
          <div className="about-main-founder-photo">
            <Image
              src="/founder-avatar.jpg"
              alt="孙晨颖"
              width={160}
              height={160}
              className="about-main-founder-avatar"
              priority
            />
          </div>
          <div className="about-main-founder-info">
            <h2 className="about-main-founder-name">孙晨颖</h2>
            <p className="about-main-founder-title">创始人 & CEO</p>
            <p className="about-main-founder-tagline">商业 × 音乐 × 科技 跨界创新引领者</p>
            <ul className="about-main-founder-edu">
              <li>香港浸会大学 公共关系与广告 学士</li>
              <li>纽约大学 音乐商业 硕士</li>
              <li>上海交通大学 人工智能方向 MBA</li>
            </ul>
            <div className="about-main-founder-bio">
              <p>
                孙晨颖拥有国际化教育背景与跨行业复合型经验，善于将文化、科技与商业融合。本科取得了香港浸会大学公共关系与广告学士学位，曾获中国大学生广告艺术节学院奖广告文案佳作奖、营销策划优秀奖，并曾在全球领先的公关咨询公司参与整合营销与企业传播战略。
              </p>
              <p>
                后赴美国纽约大学攻读音乐商业硕士，深入音乐产业中的唱片、发行、演出与流媒体等领域。就读期间在纽约多家文化创意与媒体娱乐机构从事艺人经纪、运营推广与版权管理，并曾就职于北美媒体版权与区块链科技企业，积累音乐科技与版权实务经验。
              </p>
              <p>
                曾担任美国最大的卫星广播与音频娱乐公司之一的数据分析师，负责用户留存与订阅转化等关键指标；回国后曾任某国际奢侈品牌中国区数据湖与商业智能项目负责人，从 0 到 1 搭建数据治理与可视化产品，具备全链路协作与跨部门团队管理能力。现就读上海交通大学人工智能方向 MBA，持续深耕技术与商业融合。
              </p>
              <p>
                她同时是一名独立原创音乐人，曾获中国艺术家协会「全国优秀艺术人才」勋章，已发行多首原创作品并参与词曲、编曲与制作全流程。凭借商业、艺术与科技的多元背景，她创立基音，致力于利用前沿技术驱动，为创作者建立系统化支持，让版权创造更高的艺术与商业价值。
              </p>
            </div>
          </div>
        </section>

        <p style={{ marginTop: '4rem', fontSize: '0.875rem' }}>
          <Link href={getBrandHomeUrl()} className="link-hover">&lt; 返回首页</Link>
        </p>
      </main>
      <MarketingFooter />
    </div>
  );
}
